var ProductionTypeModel = function (pageModelHndl) {
    var that = this;

    //baseData
    that.ProductionTypeId = ko.observable();
    that.Name = ko.observable();
    that.PriceFactor = ko.observable();
    that.ProductionTime = ko.observable();
    that.DisplayDate = ko.observable();

    that.PopulateProductionTypeModel = function (productionTypeData) {
        that.ProductionTypeId(productionTypeData.ProductionTypeId);
        that.Name(productionTypeData.Name);
        that.PriceFactor(productionTypeData.PriceFactor);
        that.ProductionTime(productionTypeData.ProductionTime);
        that.DisplayDate(productionTypeData.DisplayDate);
    };
};